/* import __COLOCATED_TEMPLATE__ from './inner.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class PracticeWebsiteHeaderInner extends Component {}
